/**
 * RTWO Event Bus — Event Bus Registry Service
 */

import { EVENT_BUS_SERVICE_IDS, EVENT_BUS_VERSION } from '../domain-models';
import type { EBusServiceDescriptor, IEventBusRegistryService } from '../service-interfaces';
import { BaseEBusService, type EBusServiceContext } from './base-ebus-service';

export class EventBusRegistryService extends BaseEBusService implements IEventBusRegistryService {
  readonly serviceId = EVENT_BUS_SERVICE_IDS.EVENT_BUS_REGISTRY;
  readonly serviceName = 'Event Bus Registry';
  readonly description =
    'Central registry for all Event Bus services. 12 services registered in architecture.';
  readonly integrations = ['All Event Bus Services', 'System Registry'];
  readonly requiresRealEventSources = false;

  private serviceDescriptors: EBusServiceDescriptor[] = [];

  constructor(context: EBusServiceContext) {
    super(context);
  }

  async initialize(): Promise<void> {
    this.status = 'structure_ready';
  }

  setServiceDescriptors(descriptors: EBusServiceDescriptor[]): void {
    this.serviceDescriptors = descriptors;
  }

  getAllServices(): EBusServiceDescriptor[] {
    return this.serviceDescriptors;
  }

  getService(serviceId: string): EBusServiceDescriptor | null {
    return this.serviceDescriptors.find((descriptor) => descriptor.serviceId === serviceId) ?? null;
  }

  getServiceCount(): number {
    return this.serviceDescriptors.length;
  }

  getBusRegistration() {
    return {
      moduleId: EVENT_BUS_VERSION.moduleId,
      moduleName: EVENT_BUS_VERSION.moduleName,
      phase: EVENT_BUS_VERSION.phase,
      status: EVENT_BUS_VERSION.status,
      registeredAt: Date.now(),
    };
  }
}
